import { render, staticRenderFns } from "./WebsiteSettingsTable.vue?vue&type=template&id=1b5a6289"
import script from "./WebsiteSettingsTable.vue?vue&type=script&lang=js"
export * from "./WebsiteSettingsTable.vue?vue&type=script&lang=js"
import style0 from "./WebsiteSettingsTable.vue?vue&type=style&index=0&id=1b5a6289&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports